import { Layout } from '@/components/Layout/Layout';
import ClientRecipesSubcategorySlugPage from 'components/PageLevelComponents/ClientRecipesSubcategorySlugPage';

import type { ISocialMediaComponent } from 'components/SocialMedia/types';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { RecipesSubcategoryPageController } from 'server/controller/page/recipes/subcategoryPageController';
import type { IRecipesSubcategoryPageResource } from 'server/resource/page/recipesSubcategoryPageResource';

const RootPage = (props: IRecipesSubcategoryPageResource) => {
  const {
    metaData,
    searchItemLabels,
    recipeCopy,
    breadcrumbsCMSData,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    recipeEnv,
    dynamicPageComponents,
    searchPageLabels,
    recipeCategory,
    subcategory,
    followUsData,
    host,
    isSubSubCategory,
    query,
    initialRecipes,
    numberOfRecipes,
    facets,
    refinementList,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientRecipesSubcategorySlugPage
        searchPageLabels={searchPageLabels as Record<string, string>}
        recipeCategory={recipeCategory}
        subcategory={subcategory}
        dynamicPageComponents={dynamicPageComponents}
        followUsData={followUsData as unknown as ISocialMediaComponent}
        recipeCopy={recipeCopy}
        breadcrumbsCMSData={breadcrumbsCMSData}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData}
        difficultyCopy={difficultyCopy as Record<string, string>}
        recipeEnv={recipeEnv}
        host={host}
        isSubSubCategory={isSubSubCategory}
        query={query}
        locale={locale}
        refinementList={refinementList}
        initialRecipes={initialRecipes}
        initialTotalResults={numberOfRecipes}
        initialFacets={facets}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return RecipesSubcategoryPageController.getCachedSubcategoryPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug : [],
    host: req.headers.host ?? '',
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
